import urls from './urls';
import axios from 'axios';

const personalities = {
  success: true,
  statusCode: 200,
  message: 'Execute success',
  data: {
    items: [
      {
        ItemID: 'item_0',
        ItemName: "I'm looking for some fun. Please contact me, my number is listed",
        active: false,
      },
      {
        ItemID: 'item_1',
        ItemName: "I'm looking for some func. Please contact me, mu number is listed",
        active: false,
      },
      {
        ItemID: 'item_2',
        ItemName: '25 yo Female from Sydney/ looking for fun people...',
        active: false,
      },
      {
        ItemID: 'item_3',
        ItemName: "I'm looking for some func. Please contact me, mu number is listed",
        active: false,
      },
      {
        ItemID: 'item_4',
        ItemName: "I'm looking for some func. Please contact me, mu number is listed",
        active: false,
      },
      {
        ItemID: 'item_5',
        ItemName: "I'm looking for some func. Please contact me, mu number is listed",
        active: false,
      },
    ],
  },
};
const looks = {
  success: true,
  statusCode: 200,
  message: 'Execute success',
  data: {
    items: [
      {
        ItemID: 'item_0',
        ItemName: 'People often comment that I am attractive but, you need to judge for yourself',
        active: false,
      },
      {
        ItemID: 'item_1',
        ItemName: 'I describe mysefl as beautiful with a great figure',
        active: false,
      },
      {
        ItemID: 'item_2',
        ItemName: "I don't consItemIDer my self unacttractive but, better than average",
        active: false,
      },
      {
        ItemID: 'item_3',
        ItemName: 'My friends say that I have a pretty face and that I am gorgeous',
        active: false,
      },
      {
        ItemID: 'item_4',
        ItemName: 'I have average looks and physique but take care of my appearance',
        active: false,
      },
      {
        ItemID: 'item_5',
        ItemName: ' I am sure keep myself presentable and in good health',
        active: false,
      },
    ],
  },
};
const interests = {
  success: true,
  statusCode: 200,
  message: 'Execute success',
  data: {
    items: [
      {
        ItemID: 'item_0',
        ItemName: 'I love going out shopping and have coffee with friends',
        active: false,
      },
      {
        ItemID: 'item_1',
        ItemName: 'I enjoy watching a movie and going out for dinner',
        active: false,
      },
      {
        ItemID: 'item_2',
        ItemName: 'I love being outdoors and hanging out on the beach',
        active: false,
      },
      {
        ItemID: 'item_3',
        ItemName: 'I like to travel and discover new places',
        active: false,
      },
      {
        ItemID: 'item_4',
        ItemName: 'I prefer chilling outbat home with a good book or DVD',
        active: false,
      },
      {
        ItemID: 'item_5',
        ItemName: 'I really enjoy dancing the night way at a club or fun bar',
        active: false,
      },
    ],
  },
};
const mpbLookingFors = {
  success: true,
  statusCode: 200,
  message: 'Execute success',
  data: {
    items: [
      {
        ItemID: 'item_0',
        ItemName: "I am looking for a 'friend with benefits' and nothing more",
        active: false,
      },
      {
        ItemID: 'item_1',
        ItemName: 'I would like to get to know someone over some dates and take it from there',
        active: false,
      },
      {
        ItemID: 'item_2',
        ItemName: 'I am looking for someone who is open to having a relationship as well as fun.',
        active: false,
      },
      {
        ItemID: 'item_3',
        ItemName: 'I would like to meet someone casually but would be happy if things develop',
        active: false,
      },
      {
        ItemID: 'item_4',
        ItemName: 'I am not seeking a relationship but would like someone I could meet regularly.',
        active: false,
      },
      {
        ItemID: 'item_5',
        ItemName: "I'm looking for some fun. Please contact me, my number is listed.",
        active: false,
      },
    ],
  },
};

export default class whatAreYourInterestsApi {
  static loadPersonality() {
    // this.restClient = new RestClient();
    const url = urls.GET_PERSONALITY_DATA;
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    // return this.restClient.execute(url, ApiMethod.GET, null, true).then(res => {
    //   return res;
    // });
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static loadLooks() {
    // this.restClient = new RestClient();
    const url = urls.GET_LOOKS_DATA;
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    // return this.restClient.execute(url, ApiMethod.GET, null, true).then(res => {
    //   return res;
    // });
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static loadInterests() {
    // this.restClient = new RestClient();
    const url = urls.GET_INTERESTS_DATA;
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    // return this.restClient.execute(url, ApiMethod.GET, null, true).then(res => {
    //   return res;
    // });
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static loadProfileBuilderLookingForData(params) {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.GET_YOUR_IDEAL_MATCH_DATA + params.memberType;
    // return this.restClient.execute(url, ApiMethod.GET, null, true).then(res => {
    //   return res;
    // });
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }
}
